import type { ToteEngagementMode } from '@mote/api'
import { TickFilledIcon } from '@mote/assets/icons'
import { Block, Button } from '@mote/ui'
import { useToteCardContext } from '../ToteCardProvider'
import { getMemeSrc } from '../helpers'
import { Header, StyledImage } from './Shared.styles'
import { MemeContainer } from './Teply.styles'
import { Tesponse } from './Tesponse'
import { useMemeTimeout } from './useMemeTimeout'

export interface StudentTesponseProps {
  image: string
  tesponse: string | null
  mode: ToteEngagementMode
  onChangeResponse: () => void
}

export function StudentTesponse(props: StudentTesponseProps): JSX.Element {
  const toteCardContext = useToteCardContext()
  const shouldShowMeme = useMemeTimeout(props.image)

  if (shouldShowMeme) {
    return (
      <MemeContainer>
        <StyledImage src={getMemeSrc(props.mode, props.image)} />
      </MemeContainer>
    )
  }

  return (
    <Block gap={toteCardContext.config.spacing}>
      <Header {...toteCardContext.config.textStyles}>
        <Block as='span' layout='horizontal' align='center' gap={8}>
          <TickFilledIcon color='green.d1' width='1em' height='1em' />
          You responded
        </Block>
      </Header>
      <Tesponse mode={props.mode} tesponse={props.tesponse} />
      <Block layout='horizontal' align='center' justify='flex-end'>
        <Button
          //@ts-expect-error
          size={toteCardContext.config.size}
          aria-label='Change response'
          variant={'link'}
          text='Change response'
          onClick={props.onChangeResponse}
        />
      </Block>
    </Block>
  )
}
